import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './SignUp.css';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup, sendVerificationEmail } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }

    if (password.length < 6) {
      return setError('Password must be at least 6 characters long.');
    }

    try {
      setError('');
      setLoading(true);
      await signup(email, password);
      await sendVerificationEmail();
      navigate('/verify-email');
    } catch (err) {
      switch (err.code) {
        case 'auth/email-already-in-use':
          setError('This email address is already in use.');
          break;
        case 'auth/invalid-email':
          setError('The email address is not valid.');
          break;
        case 'auth/weak-password':
          setError('The password is too weak. It must be at least 6 characters long.');
          break;
        default:
          setError('Failed to create an account. Please try again.');
          break;
      }
    }

    setLoading(false);
  };

  return (
    <>
      <title>Sign Up - WizeHelper</title>
      <div className="signup-container" data-testid="signUp-container">
        <div className="signup-card" data-testid="signUp-card">
          <h1 className="signup-title" data-testid="signUp-title">Create Account</h1>
          <form onSubmit={handleSubmit} className="signup-form" data-testid="signUp-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
                autoComplete="email"
                data-testid="signUp-emailInput"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="new-password"
                data-testid="signUp-passwordInput"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input
                type="password"
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="new-password"
                data-testid="signUp-confirmPasswordInput"
              />
            </div>
            {error && <p className="error-message" data-testid="signUp-errorMessage">{error}</p>}
            <button type="submit" className="submit-button" disabled={loading} data-testid="signUp-submitButton">
              {loading ? 'Signing Up...' : 'Sign Up'}
            </button>
            <p className="privacy-policy-link">By signing up, you agree to our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
          </form>
          <div className="switch-form-link">
            <p>Already have an account? <Link to="/signin" data-testid="signUp-signInLink">Sign In</Link></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;